import { Component, OnDestroy, OnInit } from "@angular/core";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TemplateService } from "../../../shared/services/template.service";
import { SharedDataService } from "../../../shared/sharedData.service";

@Component({
    selector: "tpm-template-filter",
    templateUrl: "./template-filter.component.html",
    standalone: false
})
export class TemplateFilterComponent implements OnInit, OnDestroy {
    constructor(
        private templateService: TemplateService,
        private _eventBus: EventBusService,
        private _sharedDataService: SharedDataService,
        private log: NbcLoggerService
    ) {}

    buAccess: any;
    selectedBu: any;
    searchOptions = [
        { id: "TemplateName", description: "Template Name" },
        { id: "AuthorName", description: "Author Name" },
    ];
    TemplateSearchOption: any = this.searchOptions[0].id;
    TemplateSearchValue = "";

    templates!: any[] | null;
    sub = new SubSink();
    id: any;
    queryContainer: any;
    pageSize: any[] = [10, 25, 50, 100];
    filter = {
        isActive: "Y",
        searchText: "",
        search: {},
        templateTypes: [
            { name: "All Templates", order: "0", value: "All" },
            { name: "Active", order: "1", value: "Y" },
            { name: "Inactive", order: "2", value: "N" },
        ],
    };

    changeActive() {
        this.queryContainer.query.isActive = this.filter.isActive;
        this.getTimesheetTemplates();
    }
    getQueryContainer() {
        return {
            query: this.templateService.getTemplateListQuery(
                this.selectedBu.id,
                null,
                null,
                null
            ),
        };
    }

    getTimesheetTemplates() {
        this.log.trace("Get Timesheet Template");
        this.sub.sink = this.templateService
            .getTemplates(this.queryContainer.query)
            .subscribe({
                next: (result) => {
                    this.templates = result.reference.items;
                    this.queryContainer.query.totalRecords =
                        result.reference.totalRecords;
                    this.queryContainer.query.currentPage =
                        result.reference.currentPage;
                    this.queryContainer.query.pageSize =
                        result.reference.pageSize;

                    const data = {
                        queryContainer: this.queryContainer,
                        data: this.templates,
                    };
                    this._eventBus.emit(
                        new EmitEvent(
                            "getTimesheetTemplates",
                            "buildGrid",
                            data
                        )
                    );
                },
                error: (err) => {
                    this.log.error(err);
                    this.log.showError(
                        "Unable to load the timesheet template at this time. Please try again later."
                    );
                },
            });
    }

    onSortClicked(sortColumn, reverSort) {
        this.queryContainer.query.sortByColumn = sortColumn;
        this.queryContainer.query.reverseSort = reverSort;
        this.getTimesheetTemplates();
    }

    eventSearch(page: any) {
        this.queryContainer.query.currentPage = page.page;
        this.getTimesheetTemplates();
    }

    searchTemplates() {
        if (this.TemplateSearchOption === "TemplateName") {
            this.queryContainer.query.searchTerm.description =
                this.TemplateSearchValue;
            this.queryContainer.query.searchOptionId =
                this.TemplateSearchOption;
        } else {
            this.queryContainer.query.searchTerm.description =
                this.TemplateSearchValue;
            this.queryContainer.query.searchOptionId =
                this.TemplateSearchOption;
        }
        this.getTimesheetTemplates();
    }

    clearSearch() {
        this.queryContainer.query.searchTerm.description = "";
        this.TemplateSearchOption = this.searchOptions[0].id;
        this.TemplateSearchValue = "";
        this.queryContainer.query.isActive = "Y";
        this.filter.isActive = "Y";
        this.getTimesheetTemplates();
    }

    searchPage(pagesize) {
        this.queryContainer.query.pageSize = pagesize;
        this.getTimeCardQuerySearch();
    }

    getTimeCardQuerySearch() {
        this.getTimesheetTemplates();
    }
    subscribeEventHandlers() {
        this.sub.sink = this._eventBus.on("onColumnSortClick", (data: any) =>
            this.onSortClicked(data.sortByColumn, data.reverseSort)
        );
        this.sub.sink = this._eventBus.on("searchTemplates", () =>
            this.searchTemplates()
        );
    }

    ngOnInit() {
        this.sub.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => {
                this.selectedBu = selectedBu;
            });

        this.sub.sink = this._sharedDataService
            .getBuAccess()
            .subscribe((access) => {
                this.buAccess = access;
                this.queryContainer = this.getQueryContainer();
                this.queryContainer.query.currentPage = 1;
                this.queryContainer.query.sortByColumn = "name";
                this.queryContainer.query.reverseSort = false;
                if (this.queryContainer.query.BUId === 0) {
                    this.queryContainer.query.BUId =
                        this.buAccess?.businessUnitId;
                }
                this.subscribeEventHandlers();
                this.getTimeCardQuerySearch();
            });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
